export default __webpack_public_path__ + "static/media/Flag.958971be.svg";